// Classlink is an SSO provider similar to Clever available only to district users
// that are rostered through Classlink.
import {t} from "@lingui/core/macro";

import {useMarkConversion} from "@repo/analytics-learning-time";
import {LoginButton} from "@repo/auth-shared";
import {RequestInfo} from "@repo/shared-core";
import {redirect} from "@repo/urls";

import {ClasslinkIcon} from "./classlink-icon.tsx";

interface Props {
    continueURL?: string;
}

export const ClasslinkButton = ({continueURL}: Props) => {
    const markConversion = useMarkConversion();

    const handleClick = () => {
        // Start with PROD vals
        let classlinkClientID = "c1657298894422f67c3d442a8f28c6ec2e4bd675d545";
        let redirectPath = "/login/classlink/reauth";

        if (RequestInfo.IS_DEV_SERVER) {
            classlinkClientID = "c16572988944230d6a2f803743ab024fb011f127d0db";
            redirectPath = "/login/classlink_dev/reauth";
        }

        // Sample Classlink Request:
        // https://launchpad.classlink.com/oauth2/v2/auth?scope=profile&redirect_uri=http%3A%2F%2Fclasslink.com%2Fcallback&client_id=c141934310952145edfeee3df2a4079d07f217add9a018&response_type=code&state=f3dhsde
        let classlinkSearchParams =
            "?scope=profile" +
            "&redirect_uri=" +
            location.origin +
            redirectPath +
            "&client_id=" +
            classlinkClientID +
            "&response_type=code";

        if (continueURL) {
            classlinkSearchParams += "&state=" + continueURL;
        }

        const classlinkURL =
            "https://launchpad.classlink.com" + classlinkSearchParams;

        markConversion({
            id: "login_classlink_button_clicked",
        });
        redirect(classlinkURL);
    };

    return (
        <LoginButton
            size="large"
            title={t`Continue with ClassLink`}
            iconComponent={ClasslinkIcon}
            onClick={handleClick}
        />
    );
};
